export default __webpack_public_path__ + "static/media/warning.09ca9f56.svg";